import { useState, useEffect, useRef } from "react";
import { Menu, X, ChevronDown } from "lucide-react";

export default function Navbar() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [desktopTourOpen, setDesktopTourOpen] = useState(false);
    const [mobileTourOpen, setMobileTourOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close desktop dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDesktopTourOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <nav className="fixed top-0 w-full z-50 bg-black/90 backdrop-blur-md border-b border-white/10">
            <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">

                {/* LOGO */}
                <a href="/" className=" font-display italic text-white text-xl font-bold">
                    Ranmali Tours

                </a>

                {/* DESKTOP MENU */}
                <ul className="hidden md:flex items-center gap-10 text-white font-medium">
                    <li><a href="/" className="hover:text-yellow-400">Home</a></li>
                    <li><a href="/about" className="hover:text-yellow-400">About</a></li>

                    <li
                        className="relative"
                        ref={dropdownRef}
                        onMouseEnter={() => setDesktopTourOpen(true)}
                        onMouseLeave={() => setDesktopTourOpen(false)}
                    >
                        <button className="flex items-center gap-1 hover:text-yellow-400">
                            Tours <ChevronDown size={16}/>
                        </button>

                        {desktopTourOpen && (
                            <div className="absolute top-8 left-0 bg-black rounded-lg w-48">
                                <a href="/tours/day-tours"
                                   className="block px-4 py-3 hover:bg-yellow-400 hover:text-black">
                                    Day Tours
                                </a>
                                <a href="/tours/round-tours"
                                   className="block px-4 py-3 hover:bg-yellow-400 hover:text-black">
                                    Round Tours
                                </a>
                            </div>
                        )}
                    </li>

                    <li><a href="/gallery" className="hover:text-yellow-400">Gallery</a></li>
                    <li><a href="/contact" className="hover:text-yellow-400">Contact</a></li>
                </ul>

                {/* MOBILE TOGGLE */}
                <button
                    onClick={() => setMobileOpen(!mobileOpen)}
                    className="md:hidden text-white z-50"
                >
                    {mobileOpen ? <X size={28} /> : <Menu size={28} />}
                </button>
            </div>

            {/* MOBILE MENU */}
            {mobileOpen && (
                <div className="md:hidden bg-black/95 backdrop-blur-md px-6 py-6 text-white">
                    <div className="flex flex-col gap-5 text-lg font-medium">

                        <a onClick={() => setMobileOpen(false)} href="/">
                            Home
                        </a>

                        <a onClick={() => setMobileOpen(false)} href="/about">
                            About
                        </a>

                        <button
                            onClick={() => setMobileTourOpen(!mobileTourOpen)}
                            className="flex items-center gap-1"
                        >
                            Tours <ChevronDown size={16}/>
                        </button>

                        {mobileTourOpen && (
                            <div className="ml-4 flex flex-col gap-3 text-base">
                                <a
                                    onClick={() => setMobileOpen(false)}
                                    href="/tours/day-tours"
                                >
                                    Day Tours
                                </a>
                                <a
                                    onClick={() => setMobileOpen(false)}
                                    href="/tours/round-tours"
                                >
                                    Round Tours
                                </a>
                            </div>
                        )}
                        <a onClick={() => setMobileOpen(false)} href="/gallery">
                            Gallery
                        </a>
                        <a onClick={() => setMobileOpen(false)} href="/contact">
                            Contact
                        </a>
                    </div>
                </div>
            )}
        </nav>
    );
}
